


const nrOfDaysStartOnMonday = [6, 0, 1, 2, 3, 4, 5];
const nrOfDaysStartOnSunday = [0, 1, 2, 3, 4, 5, 6];



/**
 * function to pad a value with a leading 0 if required
 * @param val
 */
export function toXX(val: number) {

    // faster then pad? :val.toString().padStart(2,'0')

    if (val < 10) {
        return "0" + val;

    }
    else return "" + val;
}


/**
 * given the day of week, how many days in that week belong to the previous month, if the given date is the first day of the month? (defaults to starting the week on monday, if set to false, starts on sunday)
 * @param dayOfWeek
 * @param startWeekOnMonday
 */
export function computeNrOfDaysInPreviousMonth(dayOfWeek: number, startWeekOnMonday = true) {

    return startWeekOnMonday ? nrOfDaysStartOnMonday[dayOfWeek] : nrOfDaysStartOnSunday[dayOfWeek];

}

/**
 * given the day of week, how many days in that week belong to the next month, if that is the last day of the week? (defaults to starting the week on monday, if set to false, starts on sunday)
 * @param dayOfWeek
 * @param startWeekOnMonday
 */
export function computeNrOfDaysInNextMonth(dayOfWeek: number, startWeekOnMonday = true) {

    return 6 - (startWeekOnMonday ? nrOfDaysStartOnMonday[dayOfWeek] : nrOfDaysStartOnSunday[dayOfWeek]);

}




const monthFormatter = new Intl.DateTimeFormat(undefined, { month: 'long', timeZone: 'UTC' });

export function computeNameOfMonth(jsMonth: number) {

    return monthFormatter.format(new Date(`2017-${toXX(jsMonth + 1)}-01T00:00:00+00:00`));

}

// this seems to be off by one depending on locale?
//export function computeNameOfMonthWithDate(date: Date) {

//    return monthFormatter.format(date);

//}

const oneDayMs = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
const refDate = new Date(2020, 0, 1).getTime();

/**
 * returns the LtDate representation of a given date time
 * @param day
 * @param jsMonth
 * @param year
 * @param ltDateRefYear
 */
export function computeLtDate(day: number, jsMonth: number, year: number): number {


    const date = new Date(year, jsMonth, day).getTime();
   // const refDate = new Date(ltDateRefYear, 0, 1).getTime();

    return Math.round(Math.abs((date - refDate) / oneDayMs));

}

/**
 * returns the LtDate representation of a given date time
 * @param day
 * @param month
 * @param year
 * @param ltDateRefYear
 */
export function computeLtDateFromDate(date: Date | undefined): number | undefined {

    if (!date) return undefined;

    return Math.round(Math.abs((date.getTime() - refDate) / oneDayMs));

}

/**
 * Converts an ltdate back to a date.
 * @param val
 */
export function fromLtDate(val: number | undefined): Date| undefined {

    if (!val) return undefined;

    const date = new Date(refDate.valueOf());
    date.setDate(date.getDate() + val);

    return date;

}


/**
 * will format a date as yyyy-mm-dd, with leading zeros if required.
 * to be used in an input type=date or querystring.
 * @param date
 */
export function toYYYYMMDD(date: Date | undefined) {

    if (date) {

        return `${date.getFullYear()}-${toXX(date.getMonth() + 1)}-${toXX(date.getDate())}`;

    }
    else return "";
}

/**
 * parse date that will return undefined if the value is not a string. value
 * should be in a valid string format for the new Date constructor.
 * @param str
 */
export function parseDate(str: string | undefined | null): Date | undefined {

    if (!str) return undefined;

    return new Date(str);

}

const displayDateCurrentFormat = new Intl.DateTimeFormat([], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
const displayShortDateCurrentFormat = new Intl.DateTimeFormat([], { weekday: 'short', month: 'short', day: 'numeric' });
const displayShortDateNoWeekdayCurrentFormat = new Intl.DateTimeFormat([], { month: 'short', day: 'numeric' });
const displayMonthNameAndYearFormat = new Intl.DateTimeFormat([], { month: 'long', year: 'numeric' });


/**
 * converts a date to a long display date, using Intl functions. If the date is a string, then it is first parsed
 * to a new date. if undefined, returns empty string.
 * 
 * @param date
 */
export function displayDate(date: string | Date | undefined): string {

    if (!date) {
        return "";
    }

    return displayDateCurrentFormat.format(date instanceof Date ? date : new Date(date));
}

/**
 * converts a date to a short display date, using Intl functions. If the date is a string, then it is first parsed
 * to a new date. if undefined, returns empty string.
 * 
 * @param date
 */
export function displayShortDate(date: string | Date | undefined): string {

    if (!date) {
        return "";
    }

    return displayShortDateCurrentFormat.format(date instanceof Date ? date : new Date(date));
}

/**
 * converts a date to a short display date, using Intl functions. If the date is a string, then it is first parsed
 * to a new date. if undefined, returns empty string.
 * 
 * @param date
 */
export function displayShortDateNoWeekday(date: string | Date | undefined): string {

    if (!date) {
        return "";
    }

    return displayShortDateNoWeekdayCurrentFormat.format(date instanceof Date ? date : new Date(date));
}

/**
 * converts a date to a short display date, using Intl functions. If the date is a string, then it is first parsed
 * to a new date. if undefined, returns empty string.
 * 
 * @param date
 */
export function displayMonthAndYear(date: string | Date | undefined): string {

    if (!date) {
        return "";
    }

    return displayMonthNameAndYearFormat.format(date instanceof Date ? date : new Date(date));
}



/**
 * Converts a date format (e.g. yyyy-MM-dd) to an lt date value.
 * 
 * @param str
 */
export function parseToLtDate(str: string | undefined | null): number | undefined {
    if (!str) return undefined;

    return computeLtDateFromDate(parseDate(str));


}

